var StudentAvatar = require("components/avatars/StudentAvatar");

require("utility/icons/avatar_circle.scss");

var AvatarCircle = function(props) {
	var circleClassName = "avatarCircle";

	if (props.avatarType == "owlfonso") {
		var avatarImg = <img src={ require("owls/official-owlfonso.png") } className="avatarIcon" />;
	} else if (props.avatarType == "student") {
		if (props.initialOnly) {
			var avatarImg = <div className="avatarIcon">{ props.user.first_name.charAt(0) }</div>;
			circleClassName += " initial";
		} else {
			var avatarImg = <StudentAvatar student={ props.user } maxWidth={ 35 } />;
		}
	}

	return (
		<div className={ circleClassName }>
			{ avatarImg }
		</div>
	);
};

AvatarCircle.propTypes = StrictPropTypes({
	// which type of avatar to display in the circle
	avatarType: PropTypes.string.isRequired,

	// needed if displaying the user's avatar or initial
	user: PropTypes.object,

	// true if we want to display user's initial as a placeholder
	initialOnly: PropTypes.bool,
});

module.exports = AvatarCircle;



// WEBPACK FOOTER //
// ./modules/components/utility/icons/AvatarCircle.js